import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agentCapacityPolicies from './modules/agentCapacityPolicies';
import agents from './modules/agents';
// AI Agents (Agno nativo) — módulos aiAgents/aiConnectors/aiInboxes/aiRules/...
import aiAgentModules from './agents';
import assignmentPolicies from './modules/assignmentPolicies';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import automations from './modules/automations';
import auth from './modules/auth';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import chatRooms from './modules/chatRooms';
import contactConversations from './modules/contactConversations';
import contactImports from './modules/contactImports';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import companyNotes from './modules/companyNotes';
import contacts from './modules/contacts';
import companies from './modules/companies';
import deals from './modules/deals';
import dealCustomFields from './modules/dealCustomFields';
import activities from './modules/activities';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import draftMessages from './modules/draftMessages';
import forms from './modules/forms';
import funnels from './modules/funnels';
import tasks from './modules/tasks';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import lossReasons from './modules/lossReasons';
import wonReasons from './modules/wonReasons';
import macros from './modules/macros';
import liaAgents from './modules/liaAgents';
import liaIntegrations from './modules/liaIntegrations';
import n8nCredentials from './modules/n8nCredentials';
import n8nWorkflows from './modules/n8nWorkflows';
import salesGoals from './modules/salesGoals';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import reseller from './modules/reseller';
import scheduledMessages from './modules/scheduledMessages';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import wacallsCall from './modules/wacallsCall';
import whatsappCall from './modules/whatsappCall';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';

const plugins = [];

export default createStore({
  modules: {
    ...aiAgentModules,
    accounts,
    agentBots,
    agentCapacityPolicies,
    agents,
    assignmentPolicies,
    articles,
    attributes,
    auditlogs,
    automations,
    auth,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    chatRooms,
    contactConversations,
    contactImports,
    contactLabels,
    contactNotes,
    companyNotes,
    contacts,
    companies,
    deals,
    dealCustomFields,
    activities,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    draftMessages,
    forms,
    funnels,
    tasks,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    liaAgents,
    liaIntegrations,
    lossReasons,
    wonReasons,
    macros,
    n8nCredentials,
    n8nWorkflows,
    salesGoals,
    notifications,
    portals,
    reports,
    reseller,
    scheduledMessages,
    sla,
    slaReports,
    wacallsCall,
    whatsappCall,
    summaryReports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
  },
  plugins,
});
